import { Component, Input, OnChanges } from '@angular/core';
import { DatePipe, JsonPipe, NgForOf, NgIf, NgStyle } from '@angular/common';
import { Validated } from 'it/primatoo/openapi/api/org/schemas/common/docs/_findallvalidateddocresponse/Validated';
import { TreatmentService } from '@pt/api-client';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { DownloadResponse, IoniconsFilled } from '@pt/pt-models';
import { of } from 'rxjs';
import { IonicModule } from '@ionic/angular';
import { WidgetDialogService } from '../../documents/services/widget-dialog.service';

@Component({
  standalone: true,
  selector: 'pt-obsolete-details',
  template: `
    <div class='d-flex flex-row justify-content-center align-items-center' style="min-height: 80px; margin: 10px;"
         *ngIf="loading">
      <div class='spinner-border spinner-border-sm' role='status'>
      </div>
      <span class='ms-1'>Loading...</span>
    </div>

    <div *ngIf="!loading">
      <div class="table-validated-container" *ngIf="validated.length > 0">
        <table class="table table-sm table-striped table-validated table-responsive">
          <thead>
          <tr>
            <th scope="col" class="th-aggrid">{{ 'LABELS.TITLE' | translate }}</th>
            <th scope="col" class="th-aggrid">{{ 'LABELS.VALIDATOR' | translate }}</th>
            <th scope="col" class="th-aggrid" style="min-width: 85px">{{ 'LABELS.DATE' | translate }}</th>
            <th scope="col" class="th-aggrid" style="min-width: 85px">{{ 'LABELS.NOTE' | translate }}</th>

            <th scope="col" class="th-aggrid" style="width: 50px"></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let v of validated">
            <td class="td-aggrid">
              <div class="d-flex align-items-center" style="width: fit-content;">
                <img
                  *ngIf="v.validated"
                  [ngStyle]="{'width': '20px'}"
                  [id]="'img_' + validationSuccessIcon"
                  ngbTooltip="Validato" container="body"
                  alt="" [src]="'assets/images/icon-svg/' + validationSuccessIcon">

                <ion-icon *ngIf="!v.validated"
                          name='{{iconSnapshot}}'
                          class='ion-icon' title=''
                          ngbTooltip="Snapshot" container="body"
                          [ngStyle]="{'font-size': '20px'}">
                </ion-icon>

                <span class="ms-1">{{ v.name }}</span>

              </div>
            </td>
            <td class="td-aggrid">
              <span *ngIf="v.validated">{{ v.validatorUsername }}</span>
            </td>
            <th class="td-aggrid text-ellipsis" scope="row">
              {{ v.validatedAt | date:'dd/MM/yyyy HH:mm' }}
              <span *ngIf="v.current">({{ 'LABELS.CURRENT' | translate }})</span>
            </th>
            <td class="td-aggrid">
              <span container="body" [ngbTooltip]="v.description">{{ v.description }}</span>
            </td>
            <td class="td-aggrid">
              <div class="td-action">
                <img [width]='18'
                     class="cursor-pointer ms-1 d-flex"
                     [ngbTooltip]='"LABELS.PDF" | translate' container='body'
                     src='assets/images/icon-svg/pdf.svg' alt=""
                     (click)="openValidated(v)">
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="alert alert-warning alert-missing-validated" *ngIf="validated.length === 0">
        {{ 'MESSAGE.MISSING_VALIDATED' | translate }}
      </div>
    </div>
  `,
  styles: [`
    .alert-missing-validated {
      padding: 2px 10px;
    }

    .table-validated-container {
      overflow-y: auto;
      max-height: 120px;
      margin-bottom: 10px;
      margin-top: 5px;
    }

    .table-validated {
      border: 1px solid #33333322;
      margin-bottom: 0;
    }

    .th-aggrid {
      color: #333333;
      font-size: 12px;
      padding: 5px 12px;
      background: #e2e9eb;
      font-weight: 600;
    }

    .td-aggrid {
      font-weight: normal;
      font-size: 12px;
      padding: 5px 12px;
      max-width: 200px;
      overflow: hidden;
    }

    .td-action {
      display: flex;
      align-items: center;
      justify-content: space-between;
      /*width: 75px;*/
    }
  `],
  imports: [
    JsonPipe,
    NgForOf,
    NgIf,
    TranslateModule,
    NgbTooltip,
    DatePipe,
    NgStyle,
    IonicModule
  ]
})
export class ObsoleteDetailsComponent implements OnChanges {
  @Input() docId: number;
  loading = false;
  validated: Array<Validated> = [];
  validationSuccessIcon = 'validated.svg';
  iconSnapshot = IoniconsFilled.camera;
  private loadingTimeout = 0;

  constructor(public treatmentService: TreatmentService, public widgetDialogService: WidgetDialogService) {
  }

  ngOnChanges(): void {
    this.loadValidated();
  }


  loadValidated() {
    if (this.docId) {
      this.loading = true;
      this.treatmentService.getDocumentValidated(this.docId).subscribe((validated) => {
        this.validated = validated.validatedList;
        setTimeout(() => {
          this.loading = false;
        }, this.loadingTimeout);
      }, () => {
        this.validated = [];
        setTimeout(() => {
          this.loading = false;
        }, this.loadingTimeout);
      });
    }
  }

  openValidated(validated: Validated) {
    this.treatmentService.downloadValidated(validated.id, validated.name).subscribe(
      (response: DownloadResponse) => {
        const dialog = this.widgetDialogService.runPdfPreview(of(validated.name), response);
        dialog.subscribe();
      }
    );
  }
}
